export default {
  apiKey: "AIzaSyCgIxMCZDERKhgnKyr5FIEJVrKlYNbIA4k",
  authDomain: "rawlrocks.firebaseapp.com",
  projectId: "rawlrocks",
  storageBucket: "rawlrocks.appspot.com",
  messagingSenderId: "1068304431235",
  appId: "1:1068304431235:web:7547aa7d9116376ccc03b6",
  measurementId: "G-RMF5LJLXDG",
};
